module.exports = __webpack_public_path__ + "fcc40ae.ttf";